import { Link } from 'react-router-dom';
import { Clock, Eye } from 'lucide-react';

export const PostCard = ({ article, baseUrl }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <Link
      to={`${baseUrl}/${article.slug}`}
      className="group block overflow-hidden rounded-3xl border border-slate-700 bg-slate-950/80 shadow-xl transition duration-300 hover:-translate-y-1 hover:border-primary/60 hover:shadow-2xl"
      data-testid={`post-card-${article.slug}`}
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={article.featured_image}
          alt={article.image_alt || article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-slate-950/90 to-transparent" />
      </div>
      <div className="p-6">
        <div className="flex flex-wrap items-center gap-3 text-xs uppercase tracking-[0.16em] text-slate-400 mb-4">
          <span className="rounded-full border border-primary/30 bg-primary/5 px-3 py-1 text-primary">
            {article.category}
          </span>
          <span className="flex items-center gap-1">
            <Clock size={14} />
            {formatDate(article.created_at)}
          </span>
          <span className="flex items-center gap-1">
            <Eye size={14} />
            {article.views}
          </span>
        </div>
        <h3 className="text-2xl font-semibold leading-tight text-white group-hover:text-primary transition-colors">
          {article.title}
        </h3>
        <p className="mt-4 text-sm leading-relaxed text-slate-300 line-clamp-3">
          {article.excerpt}
        </p>
        <div className="mt-6 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground font-semibold">
              {article.author?.[0] ?? 'B'}
            </div>
            <div>
              <p className="text-sm font-medium text-white">{article.author}</p>
              <p className="text-xs text-slate-500">Leia agora</p>
            </div>
          </div>
          <span className="text-primary font-semibold">→</span>
        </div>
      </div>
    </Link>
  );
};